import { color, font } from "@smoothincorg/smooth-ui"
import React from "react"
import { ReactNode } from "react"
import { ImCross } from "react-icons/im"
import styled from "styled-components"

type Props = {
  className?: string
  onClick: () => void
  children?: ReactNode
}

const Component: React.VFC<Props> = (props) => {
  return (
    <span className={`${props.className} tag`}>
      <span className={`${props.className}__text`}>{props.children}</span>
      <ImCross onClick={props.onClick} />
    </span>
  )
}

const StyledComponent = styled(Component)`
  padding: 8px 12px;
  background-color: ${color.lightGray};
  margin-right: 12px;
  margin-bottom: 12px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  &__text {
    ${font(16)};
    display: block;
    font-weight: bold;
    margin-right: 8px;
  }
`

export const Tag = StyledComponent
